import _ from 'lodash';
import axios from 'axios';
import moment from 'moment';

export default {
  state: {
    params: {},
    master: [],
    orden: 2,
    pagina: 1,
    chunks: 12,
    moneda: 'USD',
    formas: false,
    conectores: [],
    preloaderUrl: '',
    resultadosView: 1,
    ordenTarifa: false,
    tarifaConector: false,
    deshabilitados: false,
    filtros: {
      nombre: '',
      precio: {
        ARS: [0, 0],
        USD: [0, 0],
        EUR: [0, 0]
      },
      proveedores: [],
      duracion: [0, 0],
      salidas: [],
      destinos: [],
      destacados: false,
      deshabilitados: false
    },
    fichaCodigo: "",
    fichaConector: ""
  },
  mutations: {

    setParams(state, payload) {
      state.params = payload;
    },

    addResultados(state, { id, resultados, time, url }) {

      const key = _.findIndex(state.conectores, ['id', id]);
      const items = _.castArray(resultados);
      const total = items.length;

      if (total > 0) {
        state.master = state.master.concat(items);
      }

      state.conectores[key].ok = true;
      state.conectores[key].url = url;
      state.conectores[key].time = time;
      state.conectores[key].total = total;
    },
    updateConector(state, { key, url }) {
      state.conectores[key].ok = true;
      state.conectores[key].url = url;
      state.conectores[key].total = 0;
    },
    setConectores(state, conectores) {
      const items = _.map(conectores, conector => {
        conector.ok = false;
        conector.url = '';
        conector.time = 0;
        conector.total = 0;
        return conector;
      });
      state.conectores = items;
    },
    setPreloaderUrl(state, url) {
      state.preloaderUrl = url;
    },
    setResultadoView(state, id) {
      state.resultadosView = id;
    },

    /** Filtros */
    setFiltroNombre(state, payload) {
      state.pagina = 1;

      let codes = [
        [193, 'A'],
        [225, 'a'],
        [201, 'E'],
        [233, 'e'],
        [205, 'I'],
        [237, 'i'],
        [211, 'O'],
        [243, 'o'],
        [250, 'U'],
        [218, 'u'],
        [209, 'N'],
        [241, 'n'],
      ];

      codes.forEach(code => {
        for (let i = 0; i < 3; i++) {
          payload = _.replace(payload, String.fromCharCode(code[0]), code[1]);
        }
      });

      state.filtros.nombre = payload;
    },
    setFiltroPrecio(state, payload) {
      state.pagina = 1;
      state.filtros.precio[payload.moneda] = payload.montos;
    },
    setFiltroProveedores(state, payload) {
      state.pagina = 1;
      state.filtros.proveedores = payload;
    },
    setFiltroDuracion(state, payload) {
      state.pagina = 1;
      state.filtros.duracion = payload;
    },

    setMoneda(state, payload) {
      state.moneda = payload;
    },
    setOrden(state, payload) {
      state.orden = payload;
    },
    setOrdenTarifa(state, payload) {
      state.ordenTarifa = payload;
    },
    setTarifaConector(state, payload) {
      state.tarifaConector = payload;
    },
    setPagina(state, payload) {
      state.pagina = payload;
    },
    setFormas(state, payload) {
      state.formas = payload;
    },
    setFiltroSalidas(state, payload) {
      state.pagina = 1;
      state.filtros.salidas = payload;
    },
    setFiltroDestinos(state, payload) {
      state.pagina = 1;
      state.filtros.destinos = payload;
    },

    setProductoDestacar(state, { conector, codigo, destacar }) {
      let resultados = _.castArray(state.master);
      let id = _.findIndex(resultados, { proveedor: conector, codigo: codigo });
      resultados[id].destacado = destacar;
      state.master = resultados;
    },
    setProductoHabilitar(state, { codigo, conector, habilitar }) {
      let resultados = _.castArray(state.master);
      let id = _.findIndex(resultados, { proveedor: conector, codigo: codigo });
      resultados[id].habilitado = habilitar;
      state.master = resultados;
    },

    setShowDeshabilitados(state, payload) {
      state.deshabilitados = payload;
    },
    setFiltroDestacados(state, payload) {
      state.filtros.destacados = payload;
    },
    setFiltroDeshabilitados(state, payload) {
      state.filtros.deshabilitados = payload;
    },
    updateProducto(state, { codigo, conector, datos }) {
      const resultados = _.castArray(state.master);
      const index = _.findIndex(resultados, { proveedor: conector, codigo: codigo });
      state.master.splice(index, 1, {...resultados[index], ...datos})
    },
    clearFiltros(state) {
      state.filtros = {
        nombre: '',
        precio: { ARS: [0, 0], USD: [0, 0], EUR: [0, 0] },
        proveedores: [],
        duracion: [0, 0],
        salidas: [],
        destinos: [],
        destacados: false,
        deshabilitados: false
      };
    },

    setFichaCodigo(state, payload) {
      state.fichaCodigo = payload;
    },
    setFichaConector(state, payload) {
      state.fichaConector = payload;
    }

  },
  getters: {

    isMaster(state) {
      return state.master.length > 0;
    },
    getMaster(state) {
      return _.castArray(state.master);
    },
    isPreloader(state) {
      const total = state.conectores.length;
      const oks = _.filter(state.conectores, 'ok');
      const oksTotal = oks.length;
      return (total !== oksTotal);
    },
    getConectores(state) {
      return state.conectores;
    },
    getPreloaderUrl(state) {
      return state.preloaderUrl;
    },
    getPreloaderPorcentaje(state) {
      const total = state.conectores.length;
      const oks = _.filter(state.conectores, 'ok');
      const oksTotal = oks.length;

      if (total === oksTotal) {
        return 100;
      }

      return (oksTotal * 100) / total;
    },
    getResultadosFiltrados(state, getters) {
      let resultados = _.castArray(state.master);

      let moneda = state.moneda ? state.moneda : 'USD';

      /** Filtro Precio Min */
      if (state.filtros.precio[moneda][0] && state.filtros.precio[moneda][0] > getters.getFiltroPrecioMin([moneda])) {
        resultados = _.filter(resultados, resultado => {
          if (resultado.tarifa) {
            return resultado.tarifa.rules[moneda].monto >= state.filtros.precio[[moneda]][0];
          }
          return false;
        });
      }

      /** Filtro Precio Max */
      if (state.filtros.precio[moneda][1] && state.filtros.precio[moneda][1] < getters.getFiltroPrecioMax(moneda)) {
        resultados = _.filter(resultados, resultado => {
          if (resultado.tarifa) {
            return resultado.tarifa.rules[moneda].monto <= state.filtros.precio[moneda][1];
          }
          return false;
        });
      }

      /** Filtro Precio Min */
      if (state.filtros.duracion[0] && state.filtros.duracion[0] > getters.getFiltroDuracionMin) {
        resultados = _.filter(resultados, resultado => {
          return resultado.noches >= state.filtros.duracion[0];
        });
      }

      /** Filtro Precio Max */
      if (state.filtros.duracion[1] && state.filtros.duracion[1] < getters.getFiltroDuracionMax) {
        resultados = _.filter(resultados, resultado => {
          return resultado.noches <= state.filtros.duracion[1];
        });
      }

      /** Filtro Salida */
      if (state.filtros.salidas.length > 0) {
        resultados = _.filter(resultados, resultado => {
          return resultado.inicio && getters.inFiltroSalidas(resultado.inicio);
        });
      }

      /** Filtro Destinos */
      if (state.filtros.destinos.length > 0) {
        resultados = _.filter(resultados, resultado => {
          let filtro = _.map(resultado.ciudades, filtro => {
            return _.kebabCase(filtro);
          });
          return (_.intersection(state.filtros.destinos, filtro)).length > 0;
        });
      }

      /** Filtro Conector */
      if (state.filtros.proveedores.length > 0) {
        resultados = _.filter(resultados, resultado => {
          return getters.inFiltroProveedor(resultado.proveedor);
        });
      }

      /** Filtro Texto */
      if (state.filtros.nombre.length > 0) {

        let codes = [
          [193, 'A'],
          [225, 'a'],
          [201, 'E'],
          [233, 'e'],
          [205, 'I'],
          [237, 'i'],
          [211, 'O'],
          [243, 'o'],
          [250, 'U'],
          [218, 'u'],
          [209, 'N'],
          [241, 'n'],
        ];

        let entities = [
          ['&Aacute;', 'A'],
          ['&aacute;', 'a'],
          ['&Eacute;', 'E'],
          ['&eacute;', 'e'],
          ['&Iacute;', 'I'],
          ['&iacute;', 'i'],
          ['&Oacute;', 'O'],
          ['&oacute;', 'o'],
          ['&Uacute;', 'U'],
          ['&uacute;', 'u'],
          ['&Ntilde;', 'N'],
          ['&ntilde;', 'n'],
        ];


        resultados = _.filter(resultados, resultado => {
          let nombre = resultado.nombre;

          codes.forEach(code => {
            for (let i = 0; i < 3; i++) {
              nombre = _.replace(nombre, String.fromCharCode(code[0]), code[1]);
            }
          });

          entities.forEach(code => {
            for (let i = 0; i < 3; i++) {
              nombre = _.replace(nombre, code[0], code[1]);
            }
          });

          return _.includes(_.toLower(nombre), _.toLower(state.filtros.nombre));
        });
      }

      /** Filtro Destacados */
      if (state.filtros.destacados) {
        resultados = _.filter(resultados, resultado => {
          if (_.has(resultado, 'destacado') === true) {
            return resultado.destacado;
          }
          return false;
        });
      }

      /** Filtro Habilitar */
      if (!state.deshabilitados) {
        resultados = _.filter(resultados, resultado => {
          if (_.has(resultado, 'habilitado') === true) {
            return resultado.habilitado;
          }
          return true;
        });
      } else if (state.filtros.deshabilitados) {
        resultados = _.filter(resultados, resultado => {
          if (_.has(resultado, 'habilitado') === true) {
            return !resultado.habilitado;
          }
          return false;
        });
      }

      resultados = _.map(resultados, item => {
        /** URL */
        item.url_reservar = getters.getURL(`/services/${item.carpeta}/${item.codigo}`);
        item.url_consultar = getters.getURL(`/services/circuitos/consultar/${item.proveedor}/${item.codigo}`);

        /** Salidas */
        item.salidas = _.sortedUniq(item.salidas);
        item.salidas_formateadas = _.map(item.salidas, salida => {
          return moment(salida).format('DD/MM/YYYY');
        });
        return item;
      });

      return resultados;
    },
    getResultados(state, getters) {
      let resultados = getters.getResultadosFiltrados;

      /** ORDER */
      switch (state.orden) {

        case 0:
          if (getters.isOrdenTarifa) {
            resultados = _.orderBy(resultados, ['destacado', resultado => {
              const moneda = getters.getMoneda ? getters.getMoneda : resultado.moneda;
              if (resultado.tarifa) {
                return resultado.tarifa.rules[moneda].monto;
              }
              return 0;
            }], ['desc', 'asc']);
          } else {
            resultados = _.orderBy(resultados, ['destacado', resultado => {
              if (resultado.tarifa) {
                return resultado.tarifa.rules.USD.monto;
              }
              return 0;
            }], ['desc', 'asc']);
          }
          break;

        case 1:
          resultados = _.orderBy(resultados, 'nombre', 'asc');
          break;

        case 2:
          if (getters.isOrdenTarifa) {
            resultados = _.orderBy(resultados, resultado => {
              const moneda = getters.getMoneda ? getters.getMoneda : resultado.moneda;
              if (resultado.tarifa) {
                return resultado.tarifa.rules[moneda].monto;
              }
              return 0;
            }, 'asc');
          } else {
            resultados = _.orderBy(resultados, resultado => {
              if (resultado.tarifa) {
                return resultado.tarifa.rules.USD.monto;
              }
              return 0;
            }, 'asc');
          }
          break;

        case 3:
          if (getters.isOrdenTarifa) {
            resultados = _.orderBy(resultados, resultado => {
              const moneda = getters.getMoneda ? getters.getMoneda : resultado.moneda;
              if (resultado.tarifa) {
                return resultado.tarifa.rules[moneda].monto;
              }
              return 0;
            }, 'desc');
          } else {
            resultados = _.orderBy(resultados, resultado => {
              if (resultado.tarifa) {
                return resultado.tarifa.rules.USD.monto;
              }
              return 0;
            }, 'desc');
          }
          break;

        default:
          resultados = _.orderBy(resultados, 'nombre', 'asc');
          break;
      }

      /** Paginado */
      if (resultados.length > 0) {
        resultados = _.chunk(resultados, getters.getChunkSize);
        resultados = _.head(resultados);
      }

      return resultados;
    },

    getParams(state) {
      return state.params;
    },

    getTotal(state, getters) {
      return getters.getResultadosFiltrados.length;
    },
    isResultados(state, getters) {
      return getters.getTotal > 0;
    },
    isResultadosView(state) {
      return (id) => {
        return state.resultadosView === id;
      };
    },
    getPagina(state) {
      return state.pagina;
    },
    getPaginas(state, getters) {
      let paginas = getters.getResultadosFiltrados.length / state.chunks;
      paginas = _.ceil(paginas);
      return paginas;
    },
    isPaginas(state, getters) {
      return getters.getPaginas > 1;
    },
    getChunkSize(state, getters) {
      const size = state.chunks * state.pagina;
      return size;
    },
    getOrden(state) {
      return state.orden;
    },
    getMoneda(state) {
      return state.moneda;
    },
    isFormas(state) {
      return state.formas;
    },

    isOrdenTarifa(state) {
      return state.ordenTarifa;
    },
    isTarifaConector(state) {
      return state.tarifaConector;
    },

    /** Filtros */
    getFiltroNombre(state) {
      return state.filtros.nombre;
    },
    getFiltroPrecio(state) {
      return state.filtros.precio;
    },
    getFiltroPrecioMin(state) {
      return (moneda) => {
        const precios = _.map(state.master, resultado => {
          return resultado.tarifa.rules[moneda].monto;
        });
        const precio = _.min(precios);
        return (precio) ? _.round(precio) : 0;
      };
    },
    getFiltroPrecioMax(state) {
      return (moneda) => {
        const precios = _.map(state.master, resultado => {
          return resultado.tarifa.rules[moneda].monto;
        });
        const precio = _.max(precios);
        return (precio) ? _.round(precio) : 0;
      };
    },
    getFiltroProveedores(state) {
      return state.filtros.proveedores;
    },
    getFiltroProveedoresLista(state, getters) {
      let lista = _.map(state.master, resultado => {
        return {
          id: resultado.proveedor,
          nombre: resultado.proveedor_nombre,
          logo: resultado.logo
        };
      });
      lista = _.uniqBy(lista, 'id');
      lista = _.orderBy(lista, 'nombre');
      return lista;
    },
    inFiltroProveedor(state) {
      return (id) => {
        return _.indexOf(state.filtros.proveedores, id) > -1;
      };
    },
    getConectoresById(state) {
      return (id) => {
        return _.find(state.conectores, ['id', id]);
      };
    },

    getFiltroDuracionMin(state, getters) {
      let noches = _.map(state.master, resultado => {
        return _.toInteger(resultado.noches);
      });
      return _.min(noches);
    },
    getFiltroDuracionMax(state, getters) {
      let noches = _.map(state.master, resultado => {
        return _.toInteger(resultado.noches);
      });
      return _.max(noches);
    },

    inFiltroSalidas(state, getters) {
      return (id) => {
        return _.indexOf(state.filtros.salidas, _.kebabCase(id)) > -1;
      };
    },
    getFiltroSalidasLista(state, getters) {
      let salidas = [];

      state.master.forEach(resultado => {
        if (resultado.inicio) {
          salidas.push(resultado.inicio);
        }
      });

      salidas = _.uniq(salidas);
      salidas = _.orderBy(salidas);

      return _.map(salidas, salida => {
        return {
          id: _.kebabCase(salida),
          nombre: salida
        };
      });
    },

    inFiltroDestinos(state, getters) {
      return (id) => {
        return _.indexOf(state.filtros.destinos, id) > -1;
      };
    },
    getFiltroDestinosLista(state, getters) {
      let destinos = [];

      state.master.forEach(resultado => {
        destinos = destinos.concat(resultado.ciudades);
      });

      destinos = _.uniq(destinos);
      destinos = _.orderBy(destinos);

      return _.map(destinos, destino => {
        return {
          id: _.kebabCase(destino),
          nombre: destino
        };
      });
    },

    getFiltroNombreSugerido(state) {
      let resultados = _.castArray(state.master);
      resultados = _.orderBy(resultados, 'nombre');

      let codes = [
        [193, 'A'],
        [225, 'a'],
        [201, 'E'],
        [233, 'e'],
        [205, 'I'],
        [237, 'i'],
        [211, 'O'],
        [243, 'o'],
        [250, 'U'],
        [218, 'u'],
        [209, 'N'],
        [241, 'n'],
      ];

      let entities = [
        ['&Aacute;', 'A'],
        ['&aacute;', 'a'],
        ['&Eacute;', 'E'],
        ['&eacute;', 'e'],
        ['&Iacute;', 'I'],
        ['&iacute;', 'i'],
        ['&Oacute;', 'O'],
        ['&oacute;', 'o'],
        ['&Uacute;', 'U'],
        ['&uacute;', 'u'],
        ['&Ntilde;', 'N'],
        ['&ntilde;', 'n'],
      ];

      resultados = _.map(resultados, item => {
        let nombre = item.nombre;

        codes.forEach(code => {
          for (let i = 0; i < 3; i++) {
            nombre = _.replace(nombre, String.fromCharCode(code[0]), code[1]);
          }
        });

        entities.forEach(code => {
          for (let i = 0; i < 3; i++) {
            nombre = _.replace(nombre, code[0], code[1]);
          }
        });

        return nombre;
      });

      return resultados;
    },

    getFichaCodigo(state) {
      return state.fichaCodigo;
    },
    getFichaConector(state) {
      return state.fichaConector;
    }

  },
  actions: {
    buscar(context) {
      _.forEach(context.state.conectores, conector => {
        axios.get(context.getters.getURL(`/services/${conector.carpeta}/buscar`), {
          params: {
            conector: conector.id,
            salida: context.state.params.mes_salida,
            origen: context.state.params.ciudad_salida,
            destinos: context.state.params.ciudades
          }
        }).then(response => {
          let url = response.request.responseURL;
          if (response.data.data) {

            /* Redirect a la ficha del circuito */
            if (context.state.fichaConector === conector.id && context.state.fichaCodigo) {
              const items = _.castArray(response.data.data);
              const circuito = _.find(items, ['codigo', context.state.fichaCodigo]);
              if (circuito) {
                const urlFicha = `/services/${circuito.carpeta}/${circuito.codigo}`;
                window.location.href = context.getters.getURL(urlFicha);
              }
            }

            context.commit('addResultados', { id: conector.id, resultados: response.data.data, time: response.data.time, url });
          } else {
            context.commit('updateConector', { key: conector.id, url });
          }
        });
      });
    },
  }
};
